import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  input,
  output,
  viewChild,
} from '@angular/core';
import { SvgIconComponent } from 'angular-svg-icon';

@Component({
  selector: 'app-blob-preview-modal',
  standalone: true,
  imports: [SvgIconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div
      #dialog
      class="fixed inset-0 z-[100] flex items-center justify-center bg-black/70"
      tabindex="0"
      role="dialog"
      (click)="onBackdropClick($event)"
      (keydown.escape)="close.emit()">
      <button
        type="button"
        class="absolute top-4 right-4 w-10 h-10 flex items-center justify-center bg-white/20 rounded-full hover:bg-white/30 z-10"
        (click)="close.emit()">
        <svg-icon
          src="/assets/svg/x-close.svg"
          svgClass="w-6 h-6"
          class="text-white" />
      </button>

      @if (loading()) {
        <div
          class="w-8 h-8 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
      } @else if (objectUrl()) {
        <img
          [src]="objectUrl()"
          alt="Preview"
          class="max-w-[90vw] max-h-[90vh] object-contain rounded-lg"
          tabindex="-1" />
      }

      <ng-content />
    </div>
  `,
})
export class BlobPreviewModalComponent implements AfterViewInit {
  readonly objectUrl = input<string | null>(null);
  readonly loading = input(false);
  // eslint-disable-next-line @angular-eslint/no-output-native
  readonly close = output<void>();

  readonly dialog = viewChild.required<ElementRef<HTMLDivElement>>('dialog');

  ngAfterViewInit(): void {
    queueMicrotask(() => this.dialog().nativeElement.focus());
  }

  onBackdropClick(event: Event): void {
    if (event.target === event.currentTarget) {
      this.close.emit();
    }
  }
}
